import { render, staticRenderFns } from "./DragTheWords.vue?vue&type=template&id=6ebaf773&scoped=true&"
import script from "./DragTheWords.vue?vue&type=script&lang=js&"
export * from "./DragTheWords.vue?vue&type=script&lang=js&"
import style0 from "./DragTheWords.vue?vue&type=style&index=0&id=6ebaf773&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ebaf773",
  null
  
)

component.options.__file = "DragTheWords.vue"
export default component.exports